import { BillableHoursTypeConfig } from '~/data/rewarding/types';
import { NON_PRESENT_CONFIG } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const billableHoursTypeConfigUtils = () => {
  const getNonPresentHoursTypeConfig = (
    hoursType: string,
    id?: string,
  ): BillableHoursTypeConfig => {
    return {
      fEmplId: 0,
      fEmplSubUId: id || NON_PRESENT_CONFIG,
      fBillableHoursStartDate: '',
      fBillableHoursEndDate: '',
      fBillableHoursAmount: 0,
      fBillableHoursInfo: '',
      fBillableHoursType: hoursType,
      fEmplSubEnteredTime: '',
    };
  };

  const getConfigIds = (typeConfigs: BillableHoursTypeConfig[]): string[] =>
    typeConfigs.map((c) => c.fEmplSubUId);

  const findConfigById = (
    typeConfigs: BillableHoursTypeConfig[],
    configId: string,
  ): BillableHoursTypeConfig | undefined =>
    typeConfigs.find((c) => c.fEmplSubUId === configId);

  const getConfigTypes = (typeConfigs: BillableHoursTypeConfig[]): string[] =>
    typeConfigs.map((c) => c.fBillableHoursType);

  const findConfigByType = (
    typeConfigs: BillableHoursTypeConfig[],
    hoursType: string,
  ): BillableHoursTypeConfig | undefined =>
    typeConfigs.find((c) => c.fBillableHoursType === hoursType);

  const getFirstConfig = (typeConfigs: BillableHoursTypeConfig[]) =>
    typeConfigs.length === 1 ? typeConfigs[0] : undefined;

  const matchByConfigId = (
    typeConfig1?: BillableHoursTypeConfig,
    typeConfig2?: BillableHoursTypeConfig,
  ) => typeConfig1?.fEmplSubUId === typeConfig2?.fEmplSubUId;

  const matchByConfigType = (
    typeConfig1?: BillableHoursTypeConfig,
    typeConfig2?: BillableHoursTypeConfig,
  ) => typeConfig1?.fBillableHoursType === typeConfig2?.fBillableHoursType;

  const resolveOptions = (props: {
    typeConfigs: BillableHoursTypeConfig[];
    hoursType?: string;
    nonPresentId?: string;
  }) => {
    const { typeConfigs, hoursType, nonPresentId } = props;

    const foundConfig = !!hoursType
      ? findConfigByType(typeConfigs, hoursType)
      : undefined;

    return !foundConfig && !!hoursType
      ? [getNonPresentHoursTypeConfig(hoursType, nonPresentId), ...typeConfigs]
      : typeConfigs;
  };

  const getDefaultConfigs = (props: {
    typeConfigs: BillableHoursTypeConfig[];
    proposalHoursType?: string;
  }) => {
    const { typeConfigs, proposalHoursType } = props;

    const options = resolveOptions({
      typeConfigs,
      hoursType: proposalHoursType,
    });

    const onlyTypeConfig =
      options.length === 1 ? getFirstConfig(options) : undefined;

    const defaultSelected = !!proposalHoursType
      ? findConfigByType(options, proposalHoursType) || onlyTypeConfig
      : onlyTypeConfig;

    return {
      options,
      selected: defaultSelected,
    };
  };

  return {
    findConfigById,
    findConfigByType,
    getConfigIds,
    getConfigTypes,
    getDefaultConfigs,
    getFirstConfig,
    getNonPresentHoursTypeConfig,
    matchByConfigId,
    matchByConfigType,
  };
};
